import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Theme,
  makeStyles,
  FormHelperText,
  InputLabel,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IGeographicBoundaryResult } from '../utils/types';

interface CountrySelectContainerProps {
  value?: number | null;
  onChange: (value: number) => void;
  label?: string;
  containerSx?: Record<string, unknown>;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
}

export function CountrySelectContainer(props: CountrySelectContainerProps) {
  const { t } = useTranslation();

  const countries: IGeographicBoundaryResult[] = [
    {
      name: 'Türkiye',
      description: '',
      id: 18884,
      code: 'TR',
      type: {
        id: 1,
        name: 'Ülke',
        code: 'COUNTRY',
        description: 'Ülke',
        status: true,
      },
    },
    // Add other countries as needed
  ];

  return (
    <FormControl error={props.error}>
      {props.label && <InputLabel>{props.label}</InputLabel>}
      <Select
        label={props.label}
        onChange={(e) => props.onChange(Number(e.target.value))}
        value={props.value || ''}
        error={props.error}
        disabled={props.disabled}
      >
        {countries.map((ct) => (
          <MenuItem key={ct.id} value={ct.id}>
            {ct.name}
          </MenuItem>
        ))}
      </Select>
      {props.helperText && (
        <FormHelperText error={props.error}>{props.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
